export const removeNullFromObject = (obj: object) => {
	for (const key in obj) {
		if (obj[key] === null) {
			delete obj[key];
		}
	}
	return obj;
};
